import { render } from "./createAllotmentComponent.vue?vue&type=template&id=0d018efe&scoped=true"
import script from "./createAllotmentComponent.vue?vue&type=script&lang=js"
export * from "./createAllotmentComponent.vue?vue&type=script&lang=js"

import "./createAllotmentComponent.vue?vue&type=style&index=0&id=0d018efe&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d018efe"]])

export default __exports__